import React from "react";
import { ValueLabel } from "@features/ax/shared/ValueLabel";

interface TechnicalSpecificationProps {
  modelDetail: any;
}

export const TechnicalSpecificationTab: React.FC<TechnicalSpecificationProps> = ({ modelDetail }) => {
  if (!modelDetail) return null;

  const specs = modelDetail?.result?.technicalSpecifications || {};

  // Formatted operating & storage temperature ranges
  const operatingTemp = `${specs?.operatingTempratureRangeFrom ?? 'NA'} to ${specs?.operatingTempratureRangeTo}`|| "NA";

  const storageTemp = `${specs?.storageTempratureRangeFrom ?? 'NA'} to ${specs?.storageTempratureRangeTo}`|| "NA";

  // Formatted dimensions

  const specGroups = [
    {
      title: "Physical Attributes",
      items: [
        { label: "Material", value: specs?.material || "NA" },
        { label: "Weight (kg)", value: specs?.weight || "NA" },
        { label: "Color", value: specs?.color || "NA" },
        { label: "Dimensions (L × W × H mm)", value: specs?.dimension },
      ],
    },
    {
      title: "Installation Parameters",
      items: [
        { label: "Mounting Type", value: specs?.mountingType || "NA" },
        { label: "Installation Orientation", value: specs?.installationOrientation || "NA" },
        { label: "Enclosure Rating", value: specs?.enclosureRating || "NA" },
        { label: "Environmental Rating", value: specs?.environmentalRating || "NA" },
      ],
    },
    {
      title: "Environmental Parameters",
      items: [
        { label: "Operating Temperature (°C)", value: operatingTemp },
        { label: "Storage Temperature (°C)", value: storageTemp },
      ],
    },
  ];

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-150 shadow-sm space-y-8">
      {specGroups.map((group, idx) => (
        <div key={idx} className={idx > 0 ? "border-t border-gray-100 pt-6" : ""}>
          <h4 className="text-sm font-bold text-gray-900 mb-4">{group.title}</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-4">
            {group.items.map((item, itemIdx) => (
              <ValueLabel
                key={itemIdx}
                label={item.label}
                value={item.value}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TechnicalSpecificationTab;
